module.exports = __webpack_public_path__ + "img/AI_LOGO_en.4dc5a91a.png";